// extracted by mini-css-extract-plugin
module.exports = {"list":"_2U7YnyYM9DEjrbbuJ5e-mb","item":"_2gEl1EDe5TB5akdaVT8lJq","dot":"_3K7QL8Oei7_XaoBg6mqc6A","link":"_2ooCKOHEn_65HsPQ-ij3po"};